import React, { useState } from 'react';
import { Button, Grid, Paper, Box, TextField } from '@mui/material';
import { Warning } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { addNewMember } from '../store/MemberInfoSlice';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

const Item = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
}));

function OwnToastContentWithTxtInput(props) {
    /*--------------- Contents --------------------*/
    const [txtcontents, setTxtContents] = useState('');
    const newmbrdispatch = useDispatch();

    return (
        <Grid container sx={{ width: '500px' }}>
            <Grid item xs={2}>
                <Warning
                    sx={{
                        color: 'red',
                        fontSize: 70
                    }}
                />
            </Grid>
            <Grid item xs={10}>
                <Item elevation={0}>
                    <Box sx={{
                        fontWeight: 'bold',
                        padding: '5px'
                    }}>
                        {props.contents}
                    </Box>
                </Item>
            </Grid>
            <Grid item xs={4} >
                <Item elevation={0}>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        //alignItems: 'center',
                        flexDirection: 'column'
                    }}>
                        เลขประจำตัวข้าราชการ :
                    </Box>
                </Item>
            </Grid>
            <Grid item xs={8} >
                <Item elevation={0}>
                    <TextField
                        value={txtcontents}
                        inputProps={{
                            style: {
                                height: '10px',
                                width: '250px',
                                textAlign: 'center'
                            },
                        }}
                        onChange={(evt) => {
                            if (evt.target.value.length <= 10) {
                                setTxtContents(evt.target.value)
                            }
                        }}
                    />
                </Item>
            </Grid>
            <Grid item xs={6}>
                <Item elevation={0}>
                    <Box display='flex' justifyContent='flex-end'>
                        <Button
                            variant='contained'
                            sx={{ width: '100px' }}
                            onClick={() => {
                                newmbrdispatch(addNewMember([{
                                    'pers_id': props.persid,
                                    'official_id': txtcontents.concat('00'),
                                    'cellphone': '--',
                                    'offtel': '--'
                                }])).then(res => {
                                    if(res.payload.data[0].infostatus === "ลงทะเบียนผู้เข้าสอบเรียบร้อยแล้ว"){
                                        toast.success(
                                            "ลงทะเบียนผู้เข้าสอบเรียบร้อยแล้ว",
                                            {
                                                position: toast.POSITION.TOP_CENTER
                                            }
                                        );
                                        props.mbrUpdateFunc(res.payload.data[0].pers_id); //*************** updated on 17-09-2024
                                    }else{
                                        toast.error(
                                            res.payload.data[0].infostatus,
                                            {
                                                position: toast.POSITION.TOP_CENTER
                                            }
                                        ); 
                                    }
                                    props.openFunc(false);
                                })
                            }}
                        >
                            ตกลง
                        </Button>
                    </Box>
                </Item>
            </Grid>
            <Grid item xs={6}>
                <Item elevation={0}>
                    <Box display='flex' justifyContent='flex-start'>
                        <Button
                            variant='contained'
                            sx={{ width: '100px' }}
                            onClick={() => {
                                props.openFunc(false);
                            }}
                        >
                            ปิด
                        </Button>
                    </Box>
                </Item>
            </Grid>
        </Grid>
    );
}

export default OwnToastContentWithTxtInput;